import { normalizeMealTypeForSelect } from '@/utils/meal-type-utils';

export type GenericMealPlanSlotSeed = {
  mealName: string;
  mealTime: string;
  mealType: string;
  targetCalories?: number | null;
};

const toTrimmedString = (value: unknown): string => String(value ?? '').trim();

const toPositiveNumber = (value: unknown): number | undefined => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : undefined;
};

export const toGenericMealPlanSlots = (meals: unknown): GenericMealPlanSlotSeed[] => {
  if (!Array.isArray(meals)) return [];

  const slots = meals
    .map((meal): GenericMealPlanSlotSeed | null => {
      const record = meal && typeof meal === 'object' ? (meal as Record<string, unknown>) : {};
      const mealName =
        toTrimmedString(record.mealName) ||
        toTrimmedString(record.name) ||
        toTrimmedString(record.label);
      const mealTime =
        toTrimmedString(record.mealTime) ||
        toTrimmedString(record.timeSlot) ||
        toTrimmedString(record.time);
      const mealType = normalizeMealTypeForSelect(record.mealType ?? record.type ?? mealName);
      const targetCalories = toPositiveNumber(
        record.targetCalories ?? record.targetKcal ?? record.calories,
      );

      if (!mealName || !mealTime || !mealType) return null;

      return {
        mealName,
        mealTime,
        mealType,
        ...(targetCalories !== undefined ? { targetCalories } : {}),
      };
    })
    .filter((slot): slot is GenericMealPlanSlotSeed => slot !== null);

  return slots;
};
